export default __webpack_public_path__ + "static/media/logo.a7ab7db0.png";